<p-confirmDialog key="route" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmroutedelete" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true || CanAdd() == false" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true || CanAdd() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Route</button>
		<button [disabled]="IsLoading() == true || CanEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Route</button>
		<button [disabled]="IsLoading() == true || CanDelete() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			Toggle Route
		</button>
		<button [disabled]="IsLoading() == true || CanDelete() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">
			Delete Route
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstBusRoute"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedBusRoute"
		dataKey="BusRouteID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--BusRouteNbr-->
				<th>
					<p-columnFilter type="text" field="BusRouteNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusRouteDesc-->
				<th>
					<p-columnFilter type="text" field="BusRouteDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusRouteTypeDesc-->
				<th>
					<p-columnFilter field="BusRouteTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterBusRouteTypeDesc
								[ngModel]="value"
								[options]="lstBusRouteTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StudentCount-->
				<th>
					<!-- <p-columnFilter type="text" field="StudentCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--DefinedBy-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--isAllowGuestRiderDesc-->
				<th>
					<p-columnFilter field="isAllowGuestRiderDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterisAllowGuestRiderDesc
								[ngModel]="value"
								[options]="lstisAllowGuestRiderDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="BusRouteNbr">Number<p-sortIcon field="BusRouteNbr"></p-sortIcon></th>
				<th pSortableColumn="BusRouteDesc">Description<p-sortIcon field="BusRouteDesc"></p-sortIcon></th>
				<th pSortableColumn="BusRouteTypeDesc">Type<p-sortIcon field="BusRouteTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Total Students<p-sortIcon field="StudentCount"></p-sortIcon></th>
				<th pSortableColumn="DefinedByID">Defined By<p-sortIcon field="DefinedByID"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="isAllowGuestRiderDesc">Auto-Allow Guest Riders<p-sortIcon field="isAllowGuestRiderDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-BusRoute>
			<tr [pSelectableRow]="BusRoute" (dblclick)="onRowDblClick(BusRoute)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ BusRoute["BusRouteNbr"] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="BusRoute.DefinedByID <= 2 ? 'Blue' : 'Black'">
					{{ BusRoute["BusRouteDesc"] }}
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ BusRoute[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="BusRoute.DefinedByID > 2 ? 'Black' : 'Red'">
					{{ BusRoute["DefinedByDesc"] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="BusRoute.Active == true ? 'Black' : 'Red'">
					{{ BusRoute["ActiveDesc"] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="BusRoute.isAllowGuestRider == true ? 'Black' : 'Red'"
				>
					{{ BusRoute["isAllowGuestRiderDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
